import React from "react";
import Grid from "@material-ui/core/Grid";
import {createStyles, Typography} from "@material-ui/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Link from 'next/link'
import {FormattedMessage, useIntl} from "react-intl";
import {makeStyles} from "@material-ui/core/styles";

const componentStyles = makeStyles(({spacing, palette}) => createStyles({
    footerContainer: {
        backgroundColor: '#393A3F',
        padding: spacing(3),
    },
    footerLink: {
        fontSize: 16,
        color: palette.primary.main,
        textDecoration: 'none',
    },
    footNote: {
        textAlign: 'center',
        marginTop: spacing(4),
    }
}));

function Footer() {
    const intl = useIntl();
    const classes = componentStyles();

    return (
        <div className={classes.footerContainer}>
            <Grid container>
                <Grid item xs={8} sm={6}>
                    <Typography color="primary" component="div">
                        <Typography color="textPrimary" component={"h2"}><FormattedMessage id="address"/></Typography>
                        MoLabs Ltd.<br />
                        25 Vitosha Blvd., floor 2<br />
                        Sofia, Bulgaria
                    </Typography>
                    <div>
                        <FontAwesomeIcon fixedWidth icon={['far', 'phone-office']} title={intl.formatMessage({id: 'phone'})} />
                        <a className={classes.footerLink} href={"tel:+35924930255"}> +359 2 493 0255</a>
                    </div>
                    <div>
                        <FontAwesomeIcon fixedWidth icon={['far', 'phone-office']} title={intl.formatMessage({id: 'phone'})} />
                        <a className={classes.footerLink} href={"tel:+4928363469975"}> +49 2836 3469975</a>
                    </div>
                    <div>
                        <FontAwesomeIcon fixedWidth icon={['far', 'envelope']} title={intl.formatMessage({id: 'email'})}/>
                        <a className={classes.footerLink} href={"mailto:contact@molabs.de"}> contact@molabs.de</a>
                    </div>
                </Grid>
                <Grid item xs={4} sm={6}>
                    <Typography color={"textPrimary"} component={"h2"}><FormattedMessage id="links"/></Typography>
                    <Link href={"/contact"}>
                        <a className={classes.footerLink}><FormattedMessage id="contact"/></a>
                    </Link><br />
                    <Link href={"/data-protection"}>
                        <a className={classes.footerLink}><FormattedMessage id="dataProtection"/></a>
                    </Link><br />
                </Grid>
                <Grid item sm={12}>
                    <div className={classes.footNote}>
                        <small>&copy; 2021 by MoLabs Ltd.</small>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default Footer;
